import { useState } from 'react';
import { postControl } from '../api';

interface Props { onAction: () => void; }

export function ControlButtons({ onAction }: Props) {
  const [busy, setBusy] = useState<string | null>(null);
  const [lastResult, setLastResult] = useState<string>('');

  async function run(action: 'pause' | 'unpause' | 'scan') {
    if (action === 'pause' && !confirm('Pause skynet for 24h? In-flight jobs continue, new ones blocked.')) return;
    setBusy(action);
    setLastResult('');
    try {
      const r = await postControl(action);
      setLastResult(`${action}: HTTP ${r.status} — ${JSON.stringify(r.body)}`);
      onAction();
    } catch (e) {
      setLastResult(`${action} failed: ${e instanceof Error ? e.message : String(e)}`);
    } finally {
      setBusy(null);
    }
  }

  return (
    <div className="controls">
      <button onClick={() => run('pause')}   disabled={busy !== null} className="btn btn-pause">
        {busy === 'pause' ? '…' : 'Pause'}
      </button>
      <button onClick={() => run('unpause')} disabled={busy !== null} className="btn btn-unpause">
        {busy === 'unpause' ? '…' : 'Unpause'}
      </button>
      <button onClick={() => run('scan')}    disabled={busy !== null} className="btn btn-scan">
        {busy === 'scan' ? '…' : 'Scan now'}
      </button>
      {lastResult && <div className="controls-result">{lastResult}</div>}
    </div>
  );
}
